import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const subscriptionPlanChangedV1Schema = eventEnvelopeSchema.extend({
  previousPlan: z.string().min(1).max(128).optional(),
  newPlan: z.string().min(1).max(128),
  previousBillingPeriod: z.string().min(1).max(64).optional(),
  newBillingPeriod: z.string().min(1).max(64).optional(),
  stripeSubscriptionId: z.string().min(1).max(256).optional(),
});

export type SubscriptionPlanChangedV1 = z.infer<typeof subscriptionPlanChangedV1Schema>;

export const SUBSCRIPTION_PLAN_CHANGED_V1_DETAIL_TYPE =
  'subscription.plan-changed.v1' as const;
